'use client'
import {
  DecoratedSection_default
} from "./chunk-HJCFOVNG.mjs";
import {
  __async,
  __spreadProps,
  __spreadValues
} from "./chunk-UYSR6ZT4.mjs";

// src/components/newsLetter/Subscribe.tsx
import { useState } from "react";
import { useSubscribe } from "@wbk/api/hooks";
import { Button, ImageWithFallback, Input, Paper, Typography } from "@wbk/ui";
import { EMAIL_PATTERN } from "@wbk/utils";
import { useForm } from "react-hook-form";
import { twMerge as twMerge2 } from "tailwind-merge";
import { useRouter, useTranslation as useTranslation2 } from "@wbk/config";
import { useAnalytics } from "@wbk/analytics";

// src/components/newsLetter/Success.tsx
import { AnimatedCheck } from "@wbk/svg";
import { twMerge } from "tailwind-merge";
import { useTranslation } from "@wbk/config";
import { jsx, jsxs } from "react/jsx-runtime";
var SubscribeSuccessComponent = ({ className }) => {
  const { t } = useTranslation(["contentful_common"]);
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: twMerge(
        "flex flex-1 grow flex-col items-center space-y-1 p-4 text-center lg:items-start lg:px-8 lg:pb-12 lg:pt-8 lg:text-start",
        className
      ),
      children: [
        /* @__PURE__ */ jsx(AnimatedCheck, { className: "h-24 w-24" }),
        /* @__PURE__ */ jsx("h2", { className: "text-2xl uppercase md:text-4xl", children: t("contentful_common:newsletter.success") }),
        /* @__PURE__ */ jsx("p", { children: t("contentful_common:newsletter.success_desc") })
      ]
    }
  );
};
var Success_default = SubscribeSuccessComponent;

// src/components/newsLetter/Subscribe.tsx
import { jsx as jsx2, jsxs as jsxs2 } from "react/jsx-runtime";
var NewsLetterSubscribe = ({
  title,
  cardTitle,
  subtitle,
  type,
  interests = [],
  className,
  slug = "",
  design = "default",
  image,
  icon,
  label,
  as,
  backgroundColor,
  backgroundImage
}) => {
  var _a, _b, _c;
  const { locale } = useRouter();
  const { t } = useTranslation2(["contentful_common"]);
  const [success, setSuccess] = useState(false);
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    formState: { errors }
  } = useForm();
  const { mutateAsync, isPending, error } = useSubscribe();
  const { newsletterEvent } = useAnalytics();
  const email = watch("email") || "";
  const Component = as || "section";
  const onSubmit = (data) => __async(null, null, function* () {
    try {
      const values = {
        email: data.email,
        type,
        interests,
        lang: locale,
        slug
      };
      yield mutateAsync(values);
      newsletterEvent(values);
      setSuccess(true);
    } catch (error2) {
    }
  });
  if (design === "notify") {
    return /* @__PURE__ */ jsxs2(Component, { className: "container space-y-8 py-12", children: [
      /* @__PURE__ */ jsx2("h2", { children: title }),
      success ? /* @__PURE__ */ jsx2(Success_default, { className: "mx-auto max-w-[500px] items-center text-center lg:items-center" }) : /* @__PURE__ */ jsxs2(
        "form",
        {
          onSubmit: handleSubmit(onSubmit),
          className: "mx-auto flex max-w-[500px] flex-col gap-4",
          children: [
            image && /* @__PURE__ */ jsx2(
              ImageWithFallback,
              {
                src: image,
                width: 88,
                height: 88,
                className: "mx-auto max-w-[88px]"
              }
            ),
            (!!cardTitle || !!subtitle) && /* @__PURE__ */ jsxs2("div", { className: "space-y-2 text-center", children: [
              cardTitle && /* @__PURE__ */ jsx2("p", { className: "text-3xl font-semibold", children: cardTitle }),
              subtitle && /* @__PURE__ */ jsx2("p", { className: "text-text-secondary text-lg", children: subtitle })
            ] }),
            /* @__PURE__ */ jsx2(
              Input,
              __spreadProps(__spreadValues({
                label: t("contentful_common:newsletter.email"),
                className: "placeholder:text-text disabled:text-paper h-10",
                type: "email",
                placeholder: t("contentful_common:newsletter.email_placeholder"),
                "data-testid": "home_newsletter_subscribe_input"
              }, register("email", {
                required: t("contentful_common:validation.required"),
                pattern: {
                  value: EMAIL_PATTERN,
                  message: t("contentful_common:validation.invalid_email")
                }
              })), {
                onChange: (value) => {
                  setValue("email", value);
                },
                error: ((_a = errors.email) == null ? void 0 : _a.message) || (error == null ? void 0 : error.message),
                value: email,
                disabled: success,
                hideErrorSpace: true
              })
            ),
            /* @__PURE__ */ jsxs2(
              Button,
              {
                type: "submit",
                theme: "action",
                "data-testid": "home_newsletter_subscribe_button",
                className: "h-12 w-full shrink-0 gap-1",
                loading: isPending,
                disabled: success,
                children: [
                  icon && /* @__PURE__ */ jsx2("img", { src: icon, width: 24, height: 24, className: "max-w-6", alt: "" }),
                  /* @__PURE__ */ jsx2("span", { children: label || t("contentful_common:newsletter.subscribe") })
                ]
              }
            )
          ]
        }
      )
    ] });
  }
  if (design === "mini") {
    return success ? /* @__PURE__ */ jsx2(Success_default, {}) : /* @__PURE__ */ jsx2(
      "form",
      {
        onSubmit: handleSubmit(onSubmit),
        className: "xs:flex-row mt-4 flex flex-col items-start gap-2",
        children: /* @__PURE__ */ jsxs2("fieldset", { className: "relative w-full grow md:max-w-lg", children: [
          /* @__PURE__ */ jsx2(
            Input,
            __spreadProps(__spreadValues({
              className: "placeholder:text-text disabled:text-paper h-16 px-4 ltr:pr-24 rtl:pl-24",
              type: "email",
              placeholder: t("contentful_common:newsletter.email_placeholder"),
              "data-testid": "home_newsletter_subscribe_input"
            }, register("email", {
              required: t("contentful_common:validation.required"),
              pattern: {
                value: EMAIL_PATTERN,
                message: t("contentful_common:validation.invalid_email")
              }
            })), {
              onChange: (value) => {
                setValue("email", value);
              },
              error: ((_b = errors.email) == null ? void 0 : _b.message) || (error == null ? void 0 : error.message),
              value: email,
              disabled: success,
              hideErrorMark: true,
              hideErrorSpace: false
            })
          ),
          /* @__PURE__ */ jsx2(
            Button,
            {
              type: "submit",
              theme: "black",
              "data-testid": "home_newsletter_subscribe_button",
              className: "absolute top-8 flex -translate-y-1/2 items-center gap-2 ltr:right-2 rtl:left-2",
              loading: isPending,
              disabled: success,
              children: /* @__PURE__ */ jsx2(Typography, { variant: "body-S", strong: true, className: "text-white", children: t("contentful_common:notify.notify_me") })
            }
          )
        ] })
      }
    );
  }
  return /* @__PURE__ */ jsx2(
    Component,
    {
      "data-testid": "home_newsletter_subscribe",
      className: twMerge2("container py-12", className),
      children: /* @__PURE__ */ jsx2(Paper, { style: { background: `url(${backgroundImage})`, backgroundColor }, children: success ? /* @__PURE__ */ jsx2(Success_default, {}) : /* @__PURE__ */ jsxs2("div", { className: "grid grid-cols-1 gap-x-8 space-y-4 p-4 md:grid-cols-2 lg:px-8 lg:pb-12 lg:pt-10", children: [
        /* @__PURE__ */ jsxs2("div", { children: [
          /* @__PURE__ */ jsx2(Typography, { variant: "body-XL", strong: true, as: "h2", children: cardTitle || title || t("contentful_common:newsletter.title") }),
          /* @__PURE__ */ jsx2(Typography, { as: "p", variant: "body-M", children: subtitle || t("contentful_common:newsletter.description") })
        ] }),
        /* @__PURE__ */ jsxs2(
          "form",
          {
            onSubmit: handleSubmit(onSubmit),
            className: "flex flex-col items-start gap-2 sm:flex-row",
            children: [
              /* @__PURE__ */ jsx2("fieldset", { className: "w-full grow md:max-w-md", children: /* @__PURE__ */ jsx2(
                Input,
                __spreadProps(__spreadValues({
                  className: "placeholder:text-text disabled:text-paper h-10",
                  type: "email",
                  placeholder: t("contentful_common:newsletter.email_placeholder"),
                  "data-testid": "home_newsletter_subscribe_input"
                }, register("email", {
                  required: t("contentful_common:validation.required"),
                  pattern: {
                    value: EMAIL_PATTERN,
                    message: t("contentful_common:validation.invalid_email")
                  }
                })), {
                  onChange: (value) => {
                    setValue("email", value);
                  },
                  error: ((_c = errors.email) == null ? void 0 : _c.message) || (error == null ? void 0 : error.message),
                  value: email,
                  disabled: success,
                  hideErrorSpace: true
                })
              ) }),
              /* @__PURE__ */ jsx2(
                Button,
                {
                  type: "submit",
                  theme: "action",
                  "data-testid": "home_newsletter_subscribe_button",
                  className: "h-10 w-full shrink-0 px-8 sm:w-auto",
                  loading: isPending,
                  disabled: success,
                  children: label || t("contentful_common:newsletter.subscribe")
                }
              )
            ]
          }
        )
      ] }) })
    }
  );
};
var Subscribe_default = NewsLetterSubscribe;

// src/components/newsLetter/Section.tsx
import { jsx as jsx3 } from "react/jsx-runtime";
var NewsLetterSection = ({ section, slug }) => {
  var _a, _b, _c, _d, _e;
  const card = (_b = (_a = section.contentCollection) == null ? void 0 : _a.items) == null ? void 0 : _b[0];
  return /* @__PURE__ */ jsx3(DecoratedSection_default, { section, children: /* @__PURE__ */ jsx3(
    Subscribe_default,
    {
      title: section.title,
      cardTitle: card == null ? void 0 : card.title,
      subtitle: (card == null ? void 0 : card.subtitle) || section.subtitle,
      type: (card == null ? void 0 : card.href) ? "organization" : "newsletter",
      interests: slug ? [slug] : [],
      slug: (card == null ? void 0 : card.href) || "",
      image: (_c = card == null ? void 0 : card.image) == null ? void 0 : _c.url,
      icon: (_d = card == null ? void 0 : card.icon) == null ? void 0 : _d.url,
      label: card == null ? void 0 : card.buttonLabel,
      backgroundColor: card == null ? void 0 : card.color,
      backgroundImage: (_e = card == null ? void 0 : card.background) == null ? void 0 : _e.url
    }
  ) });
};
var Section_default = NewsLetterSection;

export {
  Subscribe_default,
  Section_default
};
//# sourceMappingURL=chunk-OASBKTYP.mjs.map